import Vue from 'vue'
import App from './App.vue'

import router from './router' // 必须导入router而非routes

import VueRouter from 'vue-router'
Vue.use(VueRouter) // 关键注册语句

import store from './store'

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)


// 高德地图安全配置（必须放在最前面）
window._AMapSecurityConfig = {
  securityJsCode: '25b2d44b1598acf7a9e8d7f2ec05ef5d'
};

Vue.config.productionTip = false

new Vue({
	router,  // 关键注入点
	 store,  // 必须注入
  render: h => h(App),
}).$mount('#app')
